"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.max = exports.xlarge = exports.large = exports.medium = exports.small = void 0;
// SMALL < 672px
var small;
(function (small) {
    small.start = '0px';
    small.end = '671px';
    small.columns = 4;
    small.padding = '16px';
    small.margin = '0px';
})(small || (exports.small = small = {}));
// MEDIUM 672px - 1056px
var medium;
(function (medium) {
    medium.start = '672px';
    medium.end = '1055px';
    medium.columns = 8;
    medium.padding = '16px';
    medium.margin = '0px';
})(medium || (exports.medium = medium = {}));
// LARGE 1056px - 1312 px
var large;
(function (large) {
    large.start = '1056px';
    large.end = '1311px';
    large.columns = 16;
    large.padding = '16px';
    large.margin = '16px';
})(large || (exports.large = large = {}));
// XLARGE 1312px - 1584px
var xlarge;
(function (xlarge) {
    xlarge.start = '1312px';
    xlarge.end = '1583px';
    xlarge.columns = 16;
    xlarge.padding = '16px';
    xlarge.margin = '16px';
})(xlarge || (exports.xlarge = xlarge = {}));
// MAX > 1584px
var max;
(function (max) {
    max.start = '1584px';
    max.columns = 16;
    max.padding = '16px';
    max.margin = '24px';
})(max || (exports.max = max = {}));
//# sourceMappingURL=breakpoints.js.map